module.exports = __webpack_public_path__ + "static/media/mao_chang_ku.3a6a1386.jpg";